module.exports = __webpack_public_path__ + "img/icon-sb-shop-more-desktop.5ae66c6.svg";